import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "stockist-finder" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "stockist-finder__text" };
const _hoisted_4 = { class: "stockist-finder__search" };
const _hoisted_5 = ["src"];
import { ref } from 'vue';
import { useAssets } from '../../composables/useAssets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FindYourNearestStockistMap',
    props: {
        isProductPage: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { assetUrl } = useAssets();
        const postcode = ref('');
        const submitPostcode = () => {
            const trimmed = postcode.value.trim();
            if (!trimmed)
                return;
            window.location.href = `/where-to-buy?postcode=${encodeURIComponent(trimmed)}`;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["stockist-finder__content", { 'on-product-page': __props.isProductPage }])
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "stockist-finder__title" }, " Find your nearest stockist ", -1)),
                            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "stockist-finder__subtitle" }, " Enter your town or postcode ", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((postcode).value = $event)),
                                    type: "text",
                                    placeholder: "Enter your postcode",
                                    class: "stockist-finder__input",
                                    onKeyup: _withKeys(submitPostcode, ["enter"])
                                }, null, 544), [
                                    [_vModelText, postcode.value]
                                ]),
                                _createElementVNode("button", {
                                    onClick: submitPostcode,
                                    class: "stockist-finder__button"
                                }, [
                                    _createElementVNode("img", {
                                        src: _unref(assetUrl)('/images/trade-site/search-thin.svg'),
                                        alt: "Search"
                                    }, null, 8, _hoisted_5)
                                ])
                            ])
                        ]),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stockist-finder__map" }, [
                            _createElementVNode("img", {
                                src: "/images/trade-site/map-image.png",
                                alt: "Map preview",
                                class: "stockist-finder__map-image"
                            })
                        ], -1))
                    ], 2)
                ])
            ]));
        };
    }
});
